import { render, staticRenderFns } from "./form-bmi.vue?vue&type=template&id=db5a12c0&scoped=true"
import script from "./form-bmi.vue?vue&type=script&lang=js"
export * from "./form-bmi.vue?vue&type=script&lang=js"
import style0 from "./form-bmi.vue?vue&type=style&index=0&id=db5a12c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5a12c0",
  null
  
)

export default component.exports